import React from 'react'

export default function ContentManagementSVG() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.6666 2.5H3.33329C2.41413 2.5 1.66663 3.2475 1.66663 4.16667V15.8333C1.66663 16.7525 2.41413 17.5 3.33329 17.5H16.6666C17.5858 17.5 18.3333 16.7525 18.3333 15.8333V4.16667C18.3333 3.2475 17.5858 2.5 16.6666 2.5ZM3.33329 15.8333V4.16667H9.16663V15.8333H3.33329ZM10.8333 15.8333V4.16667H16.6666L16.6675 15.8333H10.8333Z" fill="#8E8EA1" />
      <path d="M12.5 5.8335H15V7.50016H12.5V5.8335ZM12.5 9.16683H15V10.8335H12.5V9.16683Z" fill="#8E8EA1" />
    </svg>
  )
}